export enum CaseType {
	CASE = 'case',
	SET = 'set',
}

export enum CaseItemRarity {
	COMMON = 'common',
	UNCOMMON = 'uncommon',
	RARE = 'rare',
	EPIC = 'epic',
	LEGENDARY = 'legendary',
}

export enum CaseItemType {
	VEHICLE = 'vehicle',
	MONEY = 'money',
	EXP = 'exp',
	ITEM = 'item',
}

export function isSecretRewardByRarity(rarity: CaseItemRarity): boolean {
	return rarity === CaseItemRarity.EPIC || rarity === CaseItemRarity.LEGENDARY;
}
